import { render, staticRenderFns } from "./EmployeeVerificationRegisterForm.vue?vue&type=template&id=0168585a&scoped=true&"
import script from "./EmployeeVerificationRegisterForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeVerificationRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168585a",
  null
  
)

export default component.exports